/**
 * Ready-made storyboard boards. Each one opens in the storyboard editor via
 * /storyboard/editor?template=<slug> and has its own template page at
 * /storyboard-templates/<slug> (copy in content/storyboardTemplates.jsx).
 *
 * `seed` is what a new board page is created from (see FluidLayoutEditor).
 */
import { STORYBOARD_STYLE_KEY } from "./comicStyles";

export const STORYBOARD_TEMPLATES = [
  {
    slug: "16-9-widescreen",
    name: "16:9 Widescreen",
    useCase: "YouTube videos, short films, explainers and most HD video",
    seed: {
      pageSizeKey: "letter_landscape",
      comicStyleKey: STORYBOARD_STYLE_KEY,
      storyboard: { aspectKey: "16:9", layoutKey: "board_3x2", matteKey: "none", safeAreas: false },
    },
  },
  {
    slug: "2-39-cinemascope",
    name: "2.39:1 CinemaScope",
    useCase: "Feature films, music videos and anything shot anamorphic",
    seed: {
      pageSizeKey: "letter_landscape",
      comicStyleKey: STORYBOARD_STYLE_KEY,
      storyboard: { aspectKey: "2.39:1", layoutKey: "board_1x3", matteKey: "none", safeAreas: false },
    },
  },
  {
    slug: "vertical-9-16",
    name: "9:16 Vertical Video",
    useCase: "Instagram Reels, TikTok and YouTube Shorts",
    seed: {
      pageSizeKey: "letter_landscape",
      comicStyleKey: STORYBOARD_STYLE_KEY,
      storyboard: { aspectKey: "9:16", layoutKey: "board_4x1", matteKey: "none", safeAreas: false },
    },
  },
  {
    slug: "animation",
    name: "Animation",
    useCase: "2D and 3D animation, with notes beside every frame and safe areas on",
    seed: {
      pageSizeKey: "letter",
      comicStyleKey: STORYBOARD_STYLE_KEY,
      storyboard: { aspectKey: "16:9", layoutKey: "board_1x3", matteKey: "none", safeAreas: true },
    },
  },
];

export const DEFAULT_STORYBOARD_TEMPLATE = STORYBOARD_TEMPLATES[0];

export const findStoryboardTemplate = (slug) =>
  STORYBOARD_TEMPLATES.find((t) => t.slug === slug) || null;
